import React from "react";

import HomeTop from "../../components/HomeTop";
import HomeContent from "../../components/HomeContent";

const Home: React.FC = () => {
    // const services = [
    //     {
    //         title: "Heating Installation",
    //         description: "Professional installation of all heating systems.",
    //         icon: "🔥"
    //     },
    //     {
    //         title: "Boiler Services",
    //         description: "Repair and maintenance for all boiler types.",
    //         icon: "⚙️"
    //     },
    //     {
    //         title: "Energy Efficiency",
    //         description: "Solutions to reduce your energy bills.",
    //         icon: "💡"
    //     }
    // ];
    //
    // const testimonials = [
    //     {
    //         name: "Sarah Johnson",
    //         text: "Varmeego provided excellent service when our boiler broke down in winter.",
    //         rating: 5
    //     },
    //     {
    //         name: "Michael Brown",
    //         text: "Quick response and professional installation of our new heating system.",
    //         rating: 5
    //     }
    // ];

    return (
        <div className="home-page py-28">
            <HomeTop />
            <HomeContent />
        </div>

    )
};

export default Home;